import Link from 'next/link'
import { useRouter } from 'next/router'
import ReactSVG from 'react-svg'
import useTranslation from 'next-translate/useTranslation'
import { getUrlValues, getUrl } from 'SRC/modules/vehicleParts/utils/vehiclePartsUtils'

export const PriceSort = ({ isMobileDevice = false }) => {

	const { t, lang } = useTranslation('common')

	const locale = lang?.toUpperCase() || 'ME'

	const router = useRouter()

	const urlValues = getUrlValues(router.query)

	const urlLowest = getUrl({ ...urlValues, sortBy: 'priceAsc', page: 1 }, locale)
	const urlHighest = getUrl({ ...urlValues, sortBy: 'priceDesc', page: 1 }, locale)

	console.log('urlValues', urlValues)
	console.log('urlLowest', urlLowest)
	console.log('urlHighest', urlHighest)

	return !isMobileDevice ? (
		<div className="vehicle-parts-price-sort">
			<div className="vehicle-parts-price-sort__buttons">
				<Link
					as={urlLowest.asUrl}
					href={urlLowest.href} passHref
				>
					<a className={`vehicle-parts-price-sort__button ${urlValues?.sortBy === 'priceAsc' ? 'active' : ''}`}>
						{t('Najjeftinije')}
						<ReactSVG wrapper='span' src='/icons/najjeftinije.svg' beforeInjection={svg => {
							svg.setAttribute('width', '25px')
							svg.setAttribute('height', '25px')
						}} />
					</a>
				</Link>
				<Link
					as={urlHighest.asUrl}
					href={urlHighest.href} passHref
				>
					<a className={`vehicle-parts-price-sort__button ${urlValues?.sortBy === 'priceDesc' ? 'active' : ''}`}>
						{t('Najskuplje')}
						<ReactSVG wrapper='span' src='/icons/najskuplje.svg' beforeInjection={svg => {
							svg.setAttribute('width', '25px')
							svg.setAttribute('height', '25px')
						}} />
					</a>
				</Link>
			</div>
		</div>
	) : (
		<div className="vehicle-parts-price-sort vehicle-parts-price-sort" style={{ marginLeft: 'auto' }}>
			<div className="vehicle-parts-price-sort__buttons">
				<Link
					as={urlLowest.asUrl}
					href={urlLowest.href} passHref
				>
					<a className={`vehicle-parts-price-sort__button ${urlValues?.sortBy === 'priceAsc' ? 'active' : ''}`}>
						<ReactSVG wrapper='span' src='/icons/najjeftinije.svg' beforeInjection={svg => {
							svg.setAttribute('width', '25px')
							svg.setAttribute('height', '25px')
						}} />
					</a>
				</Link>
				<Link
					as={urlHighest.asUrl}
					href={urlHighest.href} passHref
				>
					<a className={`vehicle-parts-price-sort__button ${urlValues?.sortBy === 'priceDesc' ? 'active' : ''}`}>
						<ReactSVG wrapper='span' src='/icons/najskuplje.svg' beforeInjection={svg => {
							svg.setAttribute('width', '25px')
							svg.setAttribute('height', '25px')
						}} />
					</a>
				</Link>
			</div>
		</div>
	)
}

